import React from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
  ListItemAvatar,
  Avatar,
} from "@mui/material";
import { THEMES } from "lib/constants";

const UserList = ({ users, selectedUserId, handleUserClick }) => {
  const getAvatarName = (userName) => {
    try {
      if (userName.length <= 2) return userName;
      return userName
        .split(" ")
        .map((item) => item[0])
        .join("");
    } catch {
      return userName;
    }
  };
  return (
    <Box height="100%">
      <Typography
        noWrap
        sx={{ fontWeight: 700, fontSize: "0.9rem", pl: "1rem" }}
      >{`Filtered Users (${Number(users.length)})`}</Typography>
      <Box sx={{ height: "calc(100% - 25px)", overflowY: "auto" }}>
        <List>
          {users.map((user) => (
            <ListItemButton
              key={user.id}
              selected={user.id === selectedUserId}
              onClick={() => handleUserClick(user.id)}
              sx={{
                py: "0.25rem",
              }}
            >
              <ListItemAvatar
                sx={{
                  minWidth: "35px",
                }}
              >
                <Avatar
                  sx={{
                    width: 26,
                    height: 26,
                    fontSize: "0.85rem",
                    bgcolor: THEMES.PRIMARY.BLUE,
                  }}
                >
                  {user.id > 0 ? getAvatarName(user.name) : "All"}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                sx={{ "& .MuiTypography-root": { fontSize: "0.9rem" } }}
                primary={user.name}
              />
            </ListItemButton>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default UserList;
